import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import { get } from 'lodash';
import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCertificateUrl } from 'src/common/utils/format-utils';
import { Speciality } from 'src/components/applications';
import { Commission } from 'src/components/commissions';
import { _Locale } from 'src/components/commissions/BasicTable';
import { PencilIcon } from 'src/components/icons';
import { ApiApplication } from 'src/http';
import { dateFormat } from '../../../hooks';

interface CertificatesCardProps {
  item: Record<string, any>;
  specialities?: any;
  commissions?: any;
}

export const CertificatesCard: ComponentType<CertificatesCardProps> = ({
  item,
  specialities,
  commissions,
}) => {
  const { t, i18n } = useTranslation();

  const { uid, direction, createdAt } = item;
  const description = get(direction, ['description', i18n.language]);
  const date = dateFormat(new Date(createdAt), 'D.M.Y');
  const url = getCertificateUrl(uid);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    borderRadius: 1,
    p: 4,
  };
  const [_commissions, _setCommissions] = useState<Commission[] | undefined | null>(commissions);
  const [_specialities, _setSpecialities] = useState<Speciality[] | undefined | null>(specialities);
  const [certificate, setCertificate] = useState({
    specialty: item.specialty,
    commission: item.commissionId,
    specialization: item.specializationId,
    skillCategoryType: ['Oliy', 'Birinchi', 'Ikkinchi', 'Uchinchi'][
      Number(item.claimedQualification) - 1
    ],
    commandYear: '',
    commandDay: '',
    commandMonth: '',
    commandNumber: '',
    givenYear: '',
    givenDay: '',
    givenMonth: '',
    validityYear: '',
    validityDay: '',
    validityMonth: '',
  });

  const checkCommision = () => {
    let temp = specialities?.filter(
      (f: any) => Number(f.commission) === Number(certificate.commission)
    );
    _setSpecialities(temp);
  };
  useEffect(() => {
    checkCommision();
  }, [certificate.commission]);

  const changeSpecialization = () => {
    let temp = specialities?.filter((c: Speciality) => c.id === certificate.specialization)[0]
      ?.title[i18n.language as _Locale];
    setCertificate({ ...certificate, specialty: temp });
  };
  useEffect(() => {
    changeSpecialization();
  }, [certificate.specialization]);

  const updateCertificate = async () => {
    try {
      // const data =
      await ApiApplication.updateCertificate(item.id, certificate);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  // const updateData = () => {};

  return (
    <Card>
      <CardContent>
        <Modal
          open={open}
          onClose={handleClose}
          // aria-labelledby="parent-modal-title"
          // aria-describedby="parent-modal-description"
        >
          <Box sx={{ ...style, width: 500 }}>
            <Typography variant="h2">Sertifikatni o'zgartirish</Typography>
            {/* <TextField
              fullWidth
              placeholder="specialty"
              sx={{ my: 1 }}
              value={certificate.specialty}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setCertificate({ ...certificate, specialty: event.target.value });
              }}
            /> */}
            <FormControl
              sx={{
                mt: 3,
              }}
              fullWidth
            >
              <InputLabel id="demo-simple-select-label">{t('commissions')}</InputLabel>
              <Select
                required
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={certificate.commission}
                label="Age"
                onChange={(e) => {
                  setCertificate({ ...certificate, commission: e.target.value });
                }}
              >
                {_commissions?.map((c: Commission) => (
                  <MenuItem value={c.id} key={c.id}>
                    {c.title[i18n.language as _Locale]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              sx={{
                mt: 3,
              }}
              fullWidth
            >
              <InputLabel id="demo-simple-select-label">{t('specialty')}</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                required
                value={certificate.specialization}
                label="Age"
                onChange={(e) => {
                  setCertificate({ ...certificate, specialization: e.target.value });
                  console.log(e);
                }}
              >
                {_specialities?.map((c: Speciality) => (
                  <MenuItem value={c.id} key={c.id}>
                    {c.title[i18n.language as _Locale]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              sx={{
                mt: 3,
                mb: 2,
              }}
              fullWidth
            >
              <InputLabel id="demo-simple-select-label">{t('claimedQualification')}</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                required
                value={certificate.skillCategoryType}
                label="Age"
                onChange={(e) => {
                  setCertificate({ ...certificate, skillCategoryType: e.target.value });
                }}
              >
                <MenuItem value={'Oliy'}>{t('Олий')}</MenuItem>
                <MenuItem value={'Birinchi'}>{t('Биринчи')}</MenuItem>
                <MenuItem value={'Ikkinchi'}>{t('Иккинчи')}</MenuItem>
                <MenuItem value={'Uchinchi'}>{t('Учинчи')}</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="h6">{t('orderNoAndIssuedDate')}:</Typography>
            <Box display={'flex'} justifyContent={'space-between'} gap={1}>
              <TextField
                placeholder={t('certificate')}
                sx={{ my: 1 }}
                value={certificate.commandNumber}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCertificate({ ...certificate, commandNumber: event.target.value });
                }}
                onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                  event.target.value = event.target.value.toString().slice(0, 10);
                }}
              />
              <TextField
                type="number"
                placeholder={t('date')}
                sx={{ my: 1, width: 120 }}
                value={certificate.commandDay}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCertificate({ ...certificate, commandDay: event.target.value });
                }}
                onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                  event.target.value = Math.max(0, parseInt(event.target.value))
                    .toString()
                    .slice(0, 2);
                }}
              />
              <TextField
                type="number"
                placeholder={t('Oy')}
                sx={{ my: 1, width: 120 }}
                value={certificate.commandMonth}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCertificate({ ...certificate, commandMonth: event.target.value });
                }}
                onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                  event.target.value = Math.max(0, parseInt(event.target.value))
                    .toString()
                    .slice(0, 2);
                }}
              />
              <TextField
                type="number"
                placeholder={t('Yil')}
                sx={{ my: 1, width: 130 }}
                value={certificate.commandYear}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCertificate({ ...certificate, commandYear: event.target.value });
                }}
                onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                  event.target.value = Math.max(0, parseInt(event.target.value))
                    .toString()
                    .slice(0, 4);
                }}
              />
            </Box>
            <Typography variant="h6">{t('profile.passportIssueDate')}:</Typography>
            <Box display={'flex'} justifyContent={'space-between'} gap={1}>
              <TextField
                type="number"
                placeholder={t('date')}
                sx={{ my: 1 }}
                value={certificate.givenDay}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCertificate({ ...certificate, givenDay: event.target.value });
                }}
                onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                  event.target.value = Math.max(0, parseInt(event.target.value))
                    .toString()
                    .slice(0, 2);
                }}
              />
              <TextField
                placeholder={t('Oy')}
                type="number"
                sx={{ my: 1 }}
                value={certificate.givenMonth}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCertificate({ ...certificate, givenMonth: event.target.value });
                }}
                onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                  event.target.value = Math.max(0, parseInt(event.target.value))
                    .toString()
                    .slice(0, 2);
                }}
              />
              <TextField
                placeholder={t('Yil')}
                type="number"
                sx={{ my: 1 }}
                value={certificate.givenYear}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCertificate({ ...certificate, givenYear: event.target.value });
                }}
                onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                  event.target.value = Math.max(0, parseInt(event.target.value))
                    .toString()
                    .slice(0, 4);
                }}
              />
            </Box>
            <Typography variant="h6">{t('profile.passportExpireDate')}:</Typography>
            <Box display={'flex'} justifyContent={'space-between'} gap={1}>
              <TextField
                type="number"
                placeholder={t('date')}
                sx={{ my: 1 }}
                value={certificate.validityDay}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCertificate({ ...certificate, validityDay: event.target.value });
                }}
                onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                  event.target.value = Math.max(0, parseInt(event.target.value))
                    .toString()
                    .slice(0, 2);
                }}
              />
              <TextField
                type="number"
                placeholder={t('Oy')}
                sx={{ my: 1 }}
                value={certificate.validityMonth}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCertificate({ ...certificate, validityMonth: event.target.value });
                }}
                onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                  event.target.value = Math.max(0, parseInt(event.target.value))
                    .toString()
                    .slice(0, 2);
                }}
              />
              <TextField
                type="number"
                placeholder={t('Yil')}
                sx={{ my: 1 }}
                value={certificate.validityYear}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setCertificate({ ...certificate, validityYear: event.target.value });
                }}
                onInput={(event: React.ChangeEvent<HTMLInputElement>) => {
                  event.target.value = Math.max(0, parseInt(event.target.value))
                    .toString()
                    .slice(0, 4);
                }}
              />
            </Box>
            <Box display={'flex'} justifyContent={'flex-end'}>
              <Button variant="contained" onClick={updateCertificate}>
                Save
              </Button>
            </Box>
          </Box>
        </Modal>
        <Grid container spacing={2} flexWrap="nowrap">
          <Grid item>
            <img src={`/assets/certificate.jpg`} alt="" style={{ verticalAlign: 'text-bottom' }} />
          </Grid>
          <Grid container item flexGrow={2} direction="column" justifyContent="space-between">
            <Grid item>
              <Typography variant="body3" color="grey.400" mb={1}>
                {date}
              </Typography>
              <Typography variant="subtitle2" mb={1}>
                {/* {t('name.full')} */}
                {item.user.lastName + ' ' + item.user.firstName + ' ' + item.user.middleName}
              </Typography>
              <Typography variant="body2" mb={1}>
                {item.isPassed ? t('certificate', 'Сертификат') : t('certificate', 'Сертификат')} :{' '}
                <b>{uid}</b>
              </Typography>
              <Typography variant="body2" mb={1}>
                ID: <b>{item.id}</b>
              </Typography>
              <Typography variant="body2" mb={1}>
                Passport: <b> {item.user.passportNumber + item.user.passportSeries}</b>
              </Typography>
              <Typography variant="body2" mb={1}>
                {t('claimedQualification')} : {}
                <b>
                  {t(
                    ['Олий', 'Биринчи', 'Иккинчи', 'Учинчи'][Number(item.claimedQualification) - 1]
                  )}
                </b>
              </Typography>
              <Typography variant="body2" mb={1}>
                {t('speciality')}: <b>{item.specialty}</b>
              </Typography>
              <Typography variant="body3">{description}</Typography>
            </Grid>
            <Grid item container spacing={1}>
              {/* <Grid item xs={6}>
                <Button href={url} target="_blank" variant="outlined" color="secondary" fullWidth>
                  {t('action.open', 'Открыть')}
                </Button>
              </Grid> */}
              <Grid item xs={6}>
                <Button
                  href={url + '?d'}
                  target="_blank"
                  variant="contained"
                  color="secondary"
                  fullWidth
                >
                  {t('action.download', 'Скачать сертификат')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Button onClick={handleOpen} variant="contained" sx={{ minWidth: 0 }}>
              <PencilIcon />
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
